"use client";
import clsx from "clsx";
import { ToastContainer, ToastOptions, toast } from "react-toastify";

export const CustomAlert = () => {
  return (
    <ToastContainer
      position="top-center"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
};

const createContent = (title: string, description?: string) => (
  <div>
    <div className={clsx(description && "font-semibold")}>{title}</div>
    {description && <p className="text-base">{description}</p>}
  </div>
);

export const SuccessAlert = (
  title: string,
  description?: string,
  options?: ToastOptions,
) => toast.success(createContent(title, description), options);
export const ErrorAlert = (
  title: string,
  description?: string,
  options?: ToastOptions,
) => toast.error(createContent(title, description), options);
export const WarningAlert = (
  title: string,
  description?: string,
  options?: ToastOptions,
) => toast.warning(createContent(title, description), options);
export const InfoAlert = (
  title: string,
  description?: string,
  options?: ToastOptions,
) => toast.info(createContent(title, description), options);
